import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=99dbc5ee&scoped=true&"
import script from "./order_details.vue?vue&type=script&lang=js&"
export * from "./order_details.vue?vue&type=script&lang=js&"
import style0 from "./order_details.vue?vue&type=style&index=0&id=99dbc5ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dbc5ee",
  null
  
)

export default component.exports